import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { ListItemText } from '@material-ui/core';
import { FocusableMenuItem } from '~/modules/common/components/FocusableMenuItem';

export const ChartDateRangeQuarterOption = ({
  isSelected,
  value,
  label,
  dateLabel,
  onClick
}) => {
  const handleOnClick = useCallback(() => onClick(value), [onClick, value]);

  return (
    <>
      <FocusableMenuItem
        isSelected={isSelected}
        value={value}
        handleOnClick={handleOnClick}
      >
        <ListItemText primary={label} secondary={dateLabel} />
      </FocusableMenuItem>
    </>
  );
};

ChartDateRangeQuarterOption.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  value: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  dateLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ChartDateRangeQuarterOption;
